import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { airlineLogos } from "../../constants/constant";
import { log } from "console";
import Badge from "../../components/basicComponent/Badge";
import {
  calculateCommission,
  calculateFare,
  parseCustomDateString,
  parseDynamicFareRules,
} from "../../constants/helper";
import UserListFilter from "./UserListFilter";
import MuiRadioButton from "../basicComponent/MuiRAdioButton";
import { useNavigate } from "react-router-dom";
import { CommissionValue, passenger } from "../../constants/types";
import { useCommission } from "../../services/customHooks/useCommission";
import { useGlobalState } from "../../services/context/AuthContext";
type FlightItemProps = {
  flightData: any;
  flightName: string;
  flightCode: string;
  flightTakeoffTime: string;
  origin: string;
  totaltime: string;
  stop: string | number;
  flightReachTime: string;
  destination: string;
  totalFare: string;
  flightImg: string;
  departureDate: string;
  departureTime: string;
  departureTerminal: string;
  checkInBaggageWeight: string;
  cabinBaggage: string;
  ArrivalDate: string;
  ArrivalTime: string;
  ArrivalTerminal: string;
  paxfare: any;
  travellersDetail: any;
  traceId?: string;
  cabin: number;
  isActive?: boolean;
  onToggle?: () => void;
};

const FlightItem = ({
  traceId,
  flightData,
  destination,
  flightCode,
  flightName,
  flightReachTime,
  flightTakeoffTime,
  origin,
  stop,
  totalFare,
  totaltime,
  flightImg,
  cabin,
  paxfare,
  travellersDetail,
  isActive,
  onToggle,
}: FlightItemProps) => {
  const { userInfo } = useGlobalState();
  // const [isActive, setIsActive] = useState(false);
  const [value, setValue] = React.useState("1");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const { commission, finalFare, ruleId } = useCommission(
    flightData,
    travellersDetail
  );

  const passengerCount =
    travellersDetail?.adultCount +
    travellersDetail?.childrenCount +
    travellersDetail?.infantCount;
  const bond = flightData?.Bonds?.[0];

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const fareData = calculateFare(paxfare);
  const { fareDetails: dynamicFareRules, emtFee } = parseDynamicFareRules(
    flightData?.FareRule
  );

  const tdeatil = {
    ...travellersDetail,
    adultFare:
      flightData?.Fare?.PaxFares?.filter((i: any) => i?.PaxType === 0)?.reduce(
        (acc: number, curr: any) => acc + (curr?.BasicFare ?? 0),
        0
      ) ?? 0,

    childFare:
      flightData?.Fare?.PaxFares?.filter((i: any) => i?.PaxType === 1)?.reduce(
        (acc: number, curr: any) => acc + (curr?.BasicFare ?? 0),
        0
      ) ?? 0,

    infantFare:
      flightData?.Fare?.PaxFares?.filter((i: any) => i?.PaxType === 2)?.reduce(
        (acc: number, curr: any) => acc + (curr?.BasicFare ?? 0),
        0
      ) ?? 0,

    totalFare: flightData?.Fare?.TotalFareWithOutMarkUp ?? 0,
    totalTax: flightData?.Fare?.TotalTaxWithOutMarkUp ?? 0,
  };

  const totalFlightFare = commission + Number(totalFare);

  const afterCommissionBaseFare = fareData.baseFare + commission;

  const currency = userInfo?.currencyCode || "AED";
  const FareMoreInfo = () => {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="_detislsnp ng-binding mb-2 d-flex align-items-center">
              <img
                width={32}
                src="media/images/flightDetail.png"
                alt="flightDetail"
              />
              <span className="ng-binding prce_mn px-2">Delhi - Mumbai </span>
              <span>Air India • Thu-20Mar2025 • Departure at</span>
              <strong className="ng-binding px-2">22:00 </strong> - Arrival at
              <strong className="ng-binding ps-2">00:15</strong>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="card" style={{ backgroundColor: "#f8fbfd" }}>
                <div className="upr_sctn">
                  <div className="flx_p">
                    <div className="dtl_plus">
                      <div className="optn_head">
                        <span className="ng-binding">PREMIUM CLASSIC</span>
                      </div>
                      <div className="fflx acntr d-flex align-items-center">
                        <div className="_ctnprce">
                          <i className="fa-solid fa-indian-rupee-sign pe-1"></i>
                          9674
                        </div>
                        <div className="prce_mn ng-binding ng-scope">
                          <i className="fa-solid fa-indian-rupee-sign pe-1"></i>
                          9324
                        </div>
                        <div className="clr" />
                      </div>
                    </div>
                    <div className="slct_optn">
                      <MuiRadioButton
                        name="example2"
                        value="selected"
                        onChange={(val) => console.log(val)}
                        variant="withOutLabel"
                      />
                    </div>
                  </div>
                </div>
                <div className="row text-end pt-2 pe-2">
                  <div className="refund-text">
                    <Badge
                      borderColor={
                        flightData?.Fare?.PaxFares?.[0]?.Refundable
                          ? "#2dca1c"
                          : "#d21404"
                      }
                      text={
                        flightData?.Fare?.PaxFares?.[0]?.Refundable
                          ? "Refundable"
                          : "Non-Refundable"
                      }
                    />
                  </div>
                </div>
                <div className="faclty">
                  <div className="_fcltechdt  fjsb d-flex mb-2">
                    <i className="fa-solid fa-suitcase-rolling pe-4"></i>
                    <div className="_dsrcp_rpt fclm">
                      <div className="_tpbldtle">Baggage</div>
                      <ul>
                        <li className="_cabinfcnl">
                          <strong>7 kg</strong> Cabin Baggage
                        </li>
                        <li className="_cabinfcnl">
                          <strong className="ng-binding pe-1">15 Kgs</strong>
                          <span>Check-in Baggage</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="_fcltechdt  d-flex fjsb mb-2">
                    <i className="fa-solid fa-cash-register pe-3"></i>
                    <div className="_dsrcp_rpt fclm">
                      <div className="_tpbldtle">Changeability</div>
                      <ul className="ng-scope">
                        <li className="_cabinfcnl">
                          Cancellation fee starts at{" "}
                          <strong className="ng-binding">
                            Rs. 3710 onwards
                          </strong>
                        </li>
                        <li className="_cabinfcnl">
                          Date Change fee starts at{" "}
                          <strong className="ng-binding">
                            Rs. 2650 onwards
                          </strong>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center mb-3">
                  <div className="w-40">
                    <div className="book-btn text-center select-btn-color">
                      Select
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card">
                <div className="upr_sctn">
                  <div className="flx_p">
                    <div className="dtl_plus">
                      <div className="optn_head">
                        <span className="ng-binding">PREMIUM CLASSIC</span>
                      </div>
                      <div className="fflx acntr d-flex align-items-center">
                        <div className="_ctnprce">
                          <i className="fa-solid fa-indian-rupee-sign pe-1"></i>
                          9674
                        </div>
                        <div className="prce_mn ng-binding ng-scope">
                          <i className="fa-solid fa-indian-rupee-sign pe-1"></i>
                          9324
                        </div>
                        <div className="clr" />
                      </div>
                    </div>
                    <div className="slct_optn">
                      <MuiRadioButton
                        name="example2"
                        value="selected"
                        onChange={(val) => console.log(val)}
                        variant="withOutLabel"
                      />
                    </div>
                  </div>
                </div>
                <div className="row text-end pt-2 pe-2">
                  <div className="refund-text">
                    <Badge borderColor="#2dca1c" text="Refundable" />
                  </div>
                </div>
                <div className="faclty">
                  <div className="_fcltechdt  fjsb d-flex mb-2">
                    <i className="fa-solid fa-suitcase-rolling pe-4"></i>
                    <div className="_dsrcp_rpt fclm">
                      <div className="_tpbldtle">Baggage</div>
                      <ul>
                        <li className="_cabinfcnl">
                          <strong>7 kg</strong> Cabin Baggage
                        </li>
                        <li className="_cabinfcnl">
                          <strong className="ng-binding pe-1">15 Kgs</strong>
                          <span>Check-in Baggage</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="_fcltechdt  d-flex fjsb mb-2">
                    <i className="fa-solid fa-cash-register pe-3"></i>
                    <div className="_dsrcp_rpt fclm">
                      <div className="_tpbldtle">Changeability</div>
                      <ul className="ng-scope">
                        <li className="_cabinfcnl">
                          Cancellation fee starts at{" "}
                          <strong className="ng-binding">
                            Rs. 3710 onwards
                          </strong>
                        </li>
                        <li className="_cabinfcnl">
                          Date Change fee starts at{" "}
                          <strong className="ng-binding">
                            Rs. 2650 onwards
                          </strong>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center mb-3">
                  <div className="w-40">
                    <div className="book-btn text-center select-btn-color">
                      Select
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="card mt-4 py-2">
              <div className=" d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="pe-3">Grand Total</div>

                  <span>
                    <div className="flight-rate">
                      <i className="fa-solid fa-indian-rupee-sign"></i> 9324
                    </div>
                  </span>
                </div>
                <div className="book-btn">Book Now</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  // console.log("flightData.Legs?.[0]", flightData?.Bonds?.[0]?.Legs);

  return (
    <>
      <div
        className={`card mt-3 `}
        style={{ padding: "0px", boxShadow: "0 0 5px 0 rgb(0, 0, 0, .10)" }}
      >
        <div
          className="flex flex-wrap justify-between items-center gap-8"
          style={{ padding: "16px 28px 0px 28px" }}
        >
          <div className="flex  items-center gap-y-0 gap-x-6 lg:gap-8 flight-list">
            <div className="flex justify-center items-center size-14 shrink-0 flight-img ">
              <img src={flightImg} alt="flightImg" />
            </div>
            <div className="grid grid-col gap-1">
              <a className="text-base font-medium text-gray-900 hover:text-primary-active mb-px">
                {flightName}
              </a>
              <span className="text-2sm text-gray-700">{flightCode}</span>
            </div>
            <div className="grid grid-col gap-1">
              <div className="flight-time">{flightTakeoffTime}</div>
              <div className="rating">
                <div className="rating-label checked">
                  <p>{origin}</p>
                </div>
              </div>
            </div>
            <div className="grid grid-col gap-1">
              <span className="text-2sm text-gray-700 text-center">
                {totaltime}
              </span>
              <div className=" text-base font-medium text-gray-900 hover:text-primary-active mb-px">
                <img
                  src="https://flight.easemytrip.com/Content/img/arow_main.png"
                  alt="arow_main"
                />
              </div>
              <span className="text-2sm text-gray-700 text-center">{`${
                stop === 0 ? "Non-Stop" : stop + "-stop"
              }`}</span>
            </div>
          </div>
          <div className="grid min-w-20">
            <div className="flight-time">{flightReachTime}</div>
            <div className="rating">
              <div className="rating-label checked">
                <p>{destination}</p>
              </div>
            </div>
          </div>
          <div className="grid  min-w-20">
            <div className="flight-rate">
              {currency} {totalFlightFare}
            </div>
            {/* <div className="rating">
                <button className="more-fare-btn" onClick={handleOpen}>
                  + More Fare
                </button>
              </div> */}
          </div>
          <div className="grid  min-w-20 book-btn-res">
            <button
              className="book-btn"
              onClick={() =>
                navigate("/flightDetail", {
                  state: {
                    outBoundData: flightData,
                    travellersDetail: tdeatil,
                    traceId: traceId,
                    cabin: cabin,
                    commission: commission,
                    ruleId,
                  },
                })
              }
            >
              Book Now
            </button>
          </div>
        </div>
        <div>
          <div className="flight-detail">
            <span
              onClick={() => {
                !!onToggle && onToggle();
                setValue("1");
              }}
            >
              Flight Details
            </span>
          </div>
        </div>
        {isActive && (
          <div className="accordion-content">
            <Box sx={{ width: "100%", typography: "body1" }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Flight Information" value="1" />
                    <Tab label="Fare Details" value="2" />
                    <Tab label="Baggage Information" value="3" />
                    <Tab label="Cancellation & Change Rule" value="4" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <div className="">
                    {flightData?.Bonds?.map((bond: any, bondIndex: number) =>
                      bond?.Legs?.map((leg: any, legIndex: number) => (
                        <div className="row" key={`${bondIndex}-${legIndex}`}>
                          {/* Flight Route */}
                          <h5 className="mb-3">
                            <span>{leg.Origin}</span>
                            <i className="fa-solid fa-arrow-right px-2"></i>
                            <span>{leg.Destination}</span>
                          </h5>

                          {/* Airline Logo */}
                          <div className="col-md-1 col-sm-1 col-6">
                            <img src={flightImg} alt="flightImg" />
                          </div>

                          {/* Flight Details */}
                          <div className="col-md-2 col-sm-2 col-6">
                            <div className="text-base font-medium text-gray-900 hover:text-primary-active mb-px">
                              {leg.FlightName}
                            </div>
                            <span className="text-2sm text-gray-700">
                              {leg.CarrierCode}
                              {"-"} {leg.FlightNumber}
                            </span>
                          </div>

                          {/* Departure Details */}
                          <div className="col-md-3 col-sm-3 col-6">
                            <div className="flight-time">
                              {leg.DepartureTime}
                            </div>
                            <div className="desti-text">
                              <p>{leg.Origin}</p>
                            </div>
                            <div>
                              <span className="text-2sm text-gray-700">
                                {(() => {
                                  const parsed = parseCustomDateString(
                                    leg.DepartureDate
                                  );
                                  return parsed
                                    ? `${parsed.day}, ${parsed.date} ${parsed.month} ${parsed.year}`
                                    : "";
                                })()}
                              </span>
                            </div>
                            <div>
                              <span className="text-2sm text-gray-700">
                                Terminal - {leg.DepartureTerminal || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Duration & Baggage Info */}
                          <div className="col-md-3 col-sm-3 col-6">
                            <span className="text-2sm text-gray-700 ps-4">
                              {leg.Duration}
                            </span>
                            <div>
                              <img
                                src="https://flight.easemytrip.com/Content/img/arow_main.png"
                                alt="Flight Route"
                              />
                            </div>
                            <span className="text-2sm text-gray-700 ps-2">
                              <i className="fa-solid fa-suitcase-rolling"></i>{" "}
                              {leg.BaggageWeight}kg | Cabin: {leg.CabinBagWT}kg
                            </span>
                          </div>

                          {/* Arrival Details */}
                          <div className="col-md-3 col-sm-3 col-6">
                            <div className="flight-time">{leg.ArrivalTime}</div>
                            <div className="desti-text">
                              <p>{leg.Destination}</p>
                            </div>
                            <div>
                              <span className="text-2sm text-gray-700">
                                {(() => {
                                  const parsed = parseCustomDateString(
                                    leg.ArrivalDate
                                  );
                                  return parsed
                                    ? `${parsed.day}, ${parsed.date} ${parsed.month} ${parsed.year}`
                                    : "";
                                })()}
                              </span>
                            </div>
                            <div>
                              <span className="text-2sm text-gray-700">
                                Terminal - {leg.ArrivalTerminal || "N/A"}
                              </span>
                            </div>
                          </div>

                          {/* Layover (if not last leg) */}
                          {bond?.Legs?.length - 1 !== legIndex && (
                            <div className="layover ng-scope">
                              <span>
                                LAYOVER :
                                <strong className="ng-binding">
                                  {leg.LayoverDuration}
                                </strong>
                              </span>
                            </div>
                          )}
                        </div>
                      ))
                    )}
                  </div>
                </TabPanel>

                <TabPanel value="2">
                  <div className="da_adultsection mb-3">
                    {/* <div className="float-left w-100 pass_head text-center">
                      <span className="fnt-wt-600">
                        <i className="fa-regular fa-user"></i> 1 Adult(s)
                      </span>
                    </div> */}
                    <div className="float-left w-100 brdr-radius-5 mg-btm-20">
                      <div className="fare-card">
                        <div className="fare-item">
                          <span>{tdeatil?.adultCount} x Adult</span>
                          <span>
                            {currency}{" "}
                            {tdeatil?.adultFare * tdeatil?.adultCount}
                          </span>
                        </div>
                        <div className="fare-item">
                          <span>{tdeatil?.childrenCount} x Child</span>
                          <span>
                            {currency}{" "}
                            {tdeatil?.childFare * tdeatil?.childrenCount}
                          </span>
                        </div>
                        <div className="fare-item">
                          <span>{tdeatil?.infantCount} x Infant</span>
                          <span>
                            {currency}{" "}
                            {tdeatil?.infantFare * tdeatil?.infantCount}
                          </span>
                        </div>

                        <div className="fare-item">
                          <span>Total Tax</span>
                          <span>
                            {currency} {tdeatil.totalTax}
                          </span>
                        </div>
                        <div className="fare-item">
                          <span>other</span>
                          <span>
                            {currency} {commission}
                          </span>
                        </div>
                        <div className="fare-item total">
                          <span>Total (Fee & Surcharge)</span>
                          <span>
                            {currency} {totalFlightFare}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value="3">
                  <div className="accordion col-lg-12" id="accordionExample">
                    <div id="collapseTwo">
                      <div className="baggagerule mgt15 mar-to-12">
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table width="100%" rules="all" border={1}>
                            <tbody>
                              <tr>
                                <th>
                                  <p className="frtbl_hd">Airline</p>
                                </th>
                                <th>
                                  <p className="frtbl_hd">Check-in Baggage</p>
                                </th>
                                <th>
                                  <p className="frtbl_hd">Cabin Baggage</p>
                                </th>
                              </tr>
                              {flightData?.Bonds?.[0]?.Legs?.map(
                                (leg: any, index: number) => (
                                  <tr
                                    ng-repeat="baggage in BaggageModel"
                                    className="ng-scope"
                                  >
                                    <td>
                                      <div
                                        className="flgi-l"
                                        style={{
                                          float: "left",
                                          width: 32,
                                          marginRight: 10,
                                        }}
                                      >
                                        <img src={flightImg} alt="flightImg" />
                                      </div>
                                      <div
                                        style={{ float: "left", fontSize: 11 }}
                                      >
                                        <p
                                          ng-bind="baggage.segDTL | split:'|':0"
                                          className="ng-binding"
                                        >
                                          {leg.FlightName}
                                        </p>
                                        <p className="ng-binding">
                                          {leg.CarrierCode}
                                          {"-"} {leg.FlightNumber}
                                        </p>
                                      </div>
                                    </td>
                                    <td className="ng-binding">
                                      {leg.BaggageWeight}Kg
                                    </td>

                                    <td className="ng-binding ng-scope">
                                      {leg.CabinBagWT}kg
                                    </td>
                                  </tr>
                                )
                              )}

                              <tr>
                                <td colSpan={3}>
                                  <div className="termsbagg">
                                    <ul>
                                      <li>
                                        Baggage information mentioned above is
                                        obtained from airline's reservation
                                        system, EWTS does not guarantee the
                                        accuracy of this information.
                                      </li>
                                      <li>
                                        The baggage allowance may vary according
                                        to stop-overs, connecting flights.
                                        changes in airline rules. etc.
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value="4">
                  <div className="card card-grid h-full min-w-full">
                    <div className="card-header">
                      <h3 className="card-title">Fare Rules</h3>
                      <div className="refund-text">
                        <Badge borderColor="#2dca1c" text="Refundable" />
                      </div>
                    </div>
                    <div className="card-body">
                      <div
                        data-datatable="true"
                        data-datatable-page-size={5}
                        className="datatable-initialized"
                      >
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table
                            className="table table-border pt-2"
                            data-datatable-table="true"
                          >
                            <thead>
                              <tr>
                                <th>
                                  <span className="sort asc">
                                    <span className="sort-label">
                                      Timeframe to Cancel
                                    </span>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">Rating</span>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">
                                      Last Modified
                                    </span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dynamicFareRules.map(
                                ({ start, end, cancelFee }) => (
                                  <tr key={`cancel-${start}-${end}`}>
                                    <td>
                                      Cancel before {end} hours of departure
                                    </td>
                                    <td>
                                      <div className="flex flex-col gap-2">
                                        <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                          {currency} {cancelFee ?? 0}
                                        </a>
                                      </div>
                                    </td>
                                    <td>
                                      <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                        {currency} {emtFee}
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        data-datatable="true"
                        data-datatable-page-size={5}
                        className="datatable-initialized"
                      >
                        <div style={{ overflowX: "auto", width: "100%" }}>
                          <table
                            className="table table-border pt-2"
                            data-datatable-table="true"
                          >
                            <thead>
                              <tr>
                                <th style={{ width: "562px" }}>
                                  <span className="sort asc">
                                    <p className="sort-label">
                                      Timeframe to Reschedule
                                    </p>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">
                                      Airline Fees
                                    </span>
                                  </span>
                                </th>
                                <th>
                                  <span className="sort">
                                    <span className="sort-label">
                                      EWTS Fees
                                    </span>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {dynamicFareRules.map(
                                ({ start, end, changeFee }) => (
                                  <tr key={`change-${start}-${end}`}>
                                    <td>
                                      Reschedule before {end} hours of departure
                                    </td>
                                    <td>
                                      <div className="flex flex-col gap-2">
                                        <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                          {currency} {changeFee ?? 0}
                                        </a>
                                      </div>
                                    </td>
                                    <td>
                                      <a className="leading-none font-medium text-sm text-gray-900 hover:text-primary">
                                        {currency} {emtFee}
                                      </a>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12 terms-h ms-4 mb-2">
                          Terms &amp; Conditions
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="terms mar10">
                            <ul style={{ display: "none" }}>
                              {/*li>Penalty is subject to 4 hours prior to departure and no changes are allowed after that.</li*/}
                              <li>
                                The charges will be on per passenger per sector
                              </li>
                              <li>
                                Rescheduling Charges = Rescheduling/Change
                                Penalty + Fare Difference (if applicable)
                              </li>
                              <li>
                                Partial cancellation is not allowed on the
                                flight tickets which are book under special
                                discounted fares
                              </li>
                              <li>
                                In case, the customer have not cancelled the
                                ticket within the stipulated time or no show
                                then only statutory taxes are refundable from
                                the respective airlines
                              </li>
                              <li>For infants there is no baggage allowance</li>
                              <li>
                                In certain situations of restricted cases, no
                                amendments and cancellation is allowed
                              </li>
                              <li>
                                Penalty from airlines needs to be reconfirmed
                                before any cancellation or amendments
                              </li>
                              <li>
                                Penalty changes in airline are indicative and
                                can be changed without any prior notice
                              </li>
                            </ul>
                            <ul>
                              <li className="ng-binding">
                                Total Rescheduling Charges Airlines Rescheduling
                                fees Fare Difference if applicable + EWTS Fees.
                              </li>
                              <li>
                                The airline cancel reschedule fees is indicative
                                and can be changed without any prior notice by
                                the airlines..
                              </li>
                              <li>
                                EaseMyTrip does not guarantee the accuracy of
                                cancel reschedule fees.
                              </li>
                              <li>
                                Partial cancellation is not allowed on the
                                flight tickets which are book under special
                                round trip discounted fares.
                              </li>
                              <li>
                                Airlines doesnt allow any additional baggage
                                allowance for any infant added in the booking
                              </li>
                              <li>
                                In certain situations of restricted cases, no
                                amendments and cancellation is allowed
                              </li>
                              <li>
                                Airlines cancel reschedule should be reconfirmed
                                before requesting for a cancellation or
                                amendment
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
        {/*-----------------pop code----------------------------  */}
        <UserListFilter
          header={"More Fare Options Available"}
          isVisible={open}
          handleClose={handleClose}
        >
          <FareMoreInfo />
        </UserListFilter>
      </div>
    </>
  );
};

export default FlightItem;
